module.exports = __webpack_public_path__ + "img/full4-min.500fbabc.png";